import React from 'react';
import { isoDateToLocalDate } from '@utmost.co/utmost-design-system';
import { getElementFields } from '../../forms/utils/getElementFields';
import MultiColumns from '../../forms/layouts/MultiColumns';
import { SmartformElementData } from '../../types';
import { useSmartFormContext } from '../../forms/utils/useSmartFormContext';
import { objectUtil } from '../../forms/utils/objectUtil';
import { pointInTimeToDate } from '../../forms/utils/dateHelpers';
import { DatePicker } from '../../fields/DatePicker';

// TODO: refactor this when validation.maxDate/minDate does not exist, its pointless extra layer of abstraction
const getMinMaxDate = (
  minMaxDate: Date | string | undefined,
  otherDateValue: Date | null,
  maxMin: [string, string] | [string, string, string | number] | undefined,
  isMax: boolean = false
) => {
  if (minMaxDate?.toString() === 'Invalid Date') {
    return pointInTimeToDate(otherDateValue, maxMin?.[2], isMax);
  }
  return minMaxDate;
};

export const Dates: React.FC<SmartformElementData> = (props) => {
  const [startDate, endDate] = getElementFields<2>(props).required;
  const { values } = useSmartFormContext();
  const startValue = isoDateToLocalDate(objectUtil.getIn(values, startDate.name));
  const endValue = isoDateToLocalDate(objectUtil.getIn(values, endDate.name));

  return (
    <MultiColumns
      xs={[12, 12]}
      elements={[
        <DatePicker
          dateFormat={props.element.params?.dateFormat}
          name={startDate.name}
          key={startDate.name}
          label={startDate.label}
          infoText={startDate.infoText}
          helpText={startDate.helpText}
          required={startDate.validation.required}
          errors={startDate.error}
          minDate={getMinMaxDate(startDate.validation.minDate, endValue, startDate.validation.min)}
          minDateMessage={startDate.validation.minDateMessage}
          maxDate={
            (getMinMaxDate(startDate.validation.maxDate, endValue, startDate.validation.max, true) || endValue) ??
            undefined
          }
          maxDateMessage={startDate.validation.maxDateMessage}
        />,
        <DatePicker
          dateFormat={props.element.params?.dateFormat}
          name={endDate.name}
          infoText={endDate.infoText}
          key={endDate.name}
          label={endDate.label}
          helpText={endDate.helpText}
          required={endDate.validation.required}
          errors={endDate.error}
          minDate={getMinMaxDate(endDate.validation.minDate, startValue, endDate.validation.min) || startValue}
          minDateMessage={endDate.validation.minDateMessage}
          maxDate={getMinMaxDate(endDate.validation.maxDate, startValue, endDate.validation.max, true)}
          maxDateMessage={endDate.validation.maxDateMessage}
        />
      ]}
    />
  );
};
